import { useState, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { Alert, experimentalStyled, Snackbar } from '@material-ui/core';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import { SiteContext } from '../context/SiteContext';

const DashboardLayoutRoot = experimentalStyled('div')(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  })
);

const DashboardLayoutWrapper = experimentalStyled('div')(
  ({ theme }) => ({
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  })
);

const DashboardLayoutContainer = experimentalStyled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden'
});

const DashboardLayoutContent = experimentalStyled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto'
});

const DashboardLayout = () => {
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const { notifyMessage, setNotifyMessage } = useContext(SiteContext);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setNotifyMessage({
      ...notifyMessage,
      open: false
    });
  };

  const logoff = () => {
    sessionStorage.setItem('user', '');
    sessionStorage.setItem('authorization', '');
    window.location.href = '/';
  };

  return (
    <DashboardLayoutRoot>
      <DashboardNavbar logOff={() => logoff()} onMobileNavOpen={() => { setMobileNavOpen(!isMobileNavOpen); }} />
      <DashboardSidebar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <DashboardLayoutWrapper>
        <DashboardLayoutContainer>
          <DashboardLayoutContent>
            <Outlet />
            <Snackbar
              open={notifyMessage.open}
              autoHideDuration={6000}
              onClose={handleClose}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <Alert onClose={handleClose} severity={notifyMessage.type}>
                {notifyMessage.text}
              </Alert>
            </Snackbar>
          </DashboardLayoutContent>
        </DashboardLayoutContainer>
      </DashboardLayoutWrapper>
    </DashboardLayoutRoot>
  );
};

export default DashboardLayout;
